import React from "react";
import { Tooltip } from "@mui/material";

import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import CustomDownload from "views/pages/manage/common/commonComponents/CustomDownload";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import NoRowOverlay from "../../holidayMaster/NoRowOverlay";

import { UploadStatus, formattedDate } from "./constants";

const TableContent = ({
  rows,
  rowCount,
  currentPage,
  onPageChange,
  isLoading,
}) => {
  const columns = [
    new AGridColDef("seqNo", "Seq No.")
      .setMinWidth(20)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),

    new AGridColDef("processInstanceId", "Process ID")
      .setMinWidth(90)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),

    new AGridColDef("uploadedOn", "Uploaded On")
      .setMinWidth(140)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={formattedDate(params?.value)}>
            <div className={`ellipsis-text-container`}>
              {formattedDate(params?.value)}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),
    new AGridColDef("uploadedBy", "Uploaded By")
      .setMinWidth(80)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),

    new AGridColDef("fileName", "File Name")
      .setMinWidth(150)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),

    new AGridColDef("remarks", "Remarks", false)
      .setMinWidth(100)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>{params?.value}</Tooltip>
        ) : (
          <div>-</div>
        )
      ),

    new AGridColDef("status", "Status")
      .setMinWidth(50)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>
              {UploadStatus({ status: params?.value })}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),

    new AGridColDef("fileKey", "Action", false)
      .setMinWidth(50)
      .renderCellComponent((params) => {
        const filePath =
          params?.row.status === "SUCCESS" ? params.value : params.row.errorKey;

        return (
          <div>
            <CustomDownload
              downloadKey={filePath}
              isIcon={true}
              permissionSet={["C", "U", "D"]}
              permissionType={"C"}
              disabled={params.row.status === "PROCESSING"}
            />
          </div>
        );
      }),
  ];

  return (
    <div style={{ height: "75vh" }}>
      <ADataGrid
        removeWrapperContainer
        // rowModesModel={rowModesModel}
        rows={rows || []}
        columns={columns}
        rowCount={rowCount}
        rowId={(row) => row.seqNo}
        rowHeight={50}
        loading={isLoading}
        currentPage={currentPage}
        nextButtonHandler={(page) => {
          onPageChange(page);
        }}
        emptyRowPlaceholder={() => <></>}
        components={{
          ...gridComponents,
          NoRowsOverlay: () => (
            <NoRowOverlay message={isLoading ? "Loading..." : null} />
          ),
        }}
        sx={gridStyles}
      />
    </div>
  );
};

export default TableContent;
